import React from 'react';

import { observer } from 'mobx-react-lite';

import { DropDownWrapper, OuterWrapper } from './styled';
import Select from 'react-select';
import theme from '@vromo/ui/components/theme';

interface Props {
  editCondition: (value: string | number) => void;
  options?: {label: string, value: string | number}[]
  value?: string
}
export default observer<Props>(({ value, editCondition, options = [] }) => (
  <OuterWrapper full>
    <DropDownWrapper full>
      <Select
        styles={{
          container: (styles) => ({
            ...styles,
            borderColor: `${theme.lightGrey}`,
            flex: 1,
            minWidth: '60%',
          }),
          control: (styles) => ({
            ...styles,
            borderColor: `${theme.lightGrey}`
          }),
          indicatorSeparator: (styles) => ({
            ...styles,
            backgroundColor: 'transparent'
          }),
          singleValue: (styles) => ({
            ...styles,
            whiteSpace: 'pre-wrap'
          })
        }}
        value={options.find(item => item.value === value)}
        onChange={(selected) =>
          editCondition(selected?.value || '')
        }
        options={options}
        placeholder="Select a value..."
        isMulti={false}
      />
        {/* <DropDown
        button={(
          <Flex horizontal="between" fullWidth>
            {value || 'Choose an option'}
            <FontAwesome
              icon="caret-down"
              style={{ marginLeft: 10 }}
            />
          </Flex>
        )}
        >
          {
            options!.map(option =>
              <DropDownChoice
                current={options.find(item => item.value === value)?.label || ''}
                key={option.value}
                label={option.label || ''}
                onChange={() =>
                  editCondition(option.value.toString())
                }
                value={option.value!.toString()}
              />
            )
          }
        </DropDown> */}
    </DropDownWrapper>
  </OuterWrapper>
))
